import axios from "axios";

export function createCustomer(person) {
    const config = {
        headers:
        {
            'Content-Type': 'application/json'
        }
    }

    const postData = person

    return axios.post(
        `https://core.pskeromais.com.br/api/v1/customer`,
        postData, config,
    );
}